import Filters from './Filters'

export default Filters



// WEBPACK FOOTER //
// ./src/components/List/components/Filters/index.js